/** @format */
'use client';
import { About as AboutClient } from '@common/model/apiClient/About';
import { Account as AccountClient } from '@common/model/apiClient/Account';
import { AdvancedUser as AdvancedUserClient } from '@common/model/apiClient/AdvancedUser';
import { Attachment as AttachmentClient } from '@common/model/apiClient/Attachment';
import { Audit as AuditClient } from '@common/model/apiClient/Audit';
import { Branch as BranchClient } from '@common/model/apiClient/Branch';
import { Brand as BrandClient } from '@common/model/apiClient/Brand';
import { Company as CompanyClient } from '@common/model/apiClient/Company';
import { CompanyBrand as CompanyBrandClient } from '@common/model/apiClient/CompanyBrand';
import { Contact as ContactClient } from '@common/model/apiClient/Contact';
import { Country as CountryClient } from '@common/model/apiClient/Country';
import { Document as DocumentClient } from '@common/model/apiClient/Document';
import { FieldConfiguration as FieldConfigurationClient } from '@common/model/apiClient/FieldConfiguration';
import { Help as HelpClient } from '@common/model/apiClient/Help';
import { Site as SiteClient } from '@common/model/apiClient/Site';
import { SSO as SSOClient } from '@common/model/apiClient/SSO';
import { Author as AuthorClient } from '@common/model/apiClient/SSO/Author';

export {
  CompanyClient,
  ContactClient,
  SiteClient,
  BranchClient,
  BrandClient,
  SSOClient,
  AccountClient,
  CompanyBrandClient,
  DocumentClient,
  FieldConfigurationClient,
  HelpClient,
  AuthorClient,
  AuditClient,
  CountryClient,
  AboutClient,
  AttachmentClient,
  AdvancedUserClient,
};
